import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message = _resolveComponent("message")!

  return (_ctx.message)
    ? (_openBlock(), _createBlock(_component_message, {
        key: 0,
        type: "negative"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.message), 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}